import { render, staticRenderFns } from "./AgentChatItem.vue?vue&type=template&id=32133aec&scoped=true&"
import script from "./AgentChatItem.vue?vue&type=script&lang=js&"
export * from "./AgentChatItem.vue?vue&type=script&lang=js&"
import style0 from "./AgentChatItem.vue?vue&type=style&index=0&id=32133aec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32133aec",
  null
  
)

export default component.exports